import script from "./IoSearchForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./IoSearchForm.vue?vue&type=script&lang=ts&setup=true"

import "./IoSearchForm.vue?vue&type=style&index=0&id=594acd36&lang=scss"

const __exports__ = script;

export default __exports__